import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, useWatch, Controller } from 'react-hook-form';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import {
  DashboardIPConsultsCOMFiltersFormProps,
  DashboardIPConsultsCOMFiltersFormSchema,
} from './DashboardIPConsultsCOMFiltersForm.types';
import { getIPConsultsCOMFilterSchema } from './DashboardIPConsultsCOMFiltersForm.schema';
import { dashboardIPConsultsCOMFiltersFormData } from './DashboardIPConsultsCOMFiltersForm.data';
import Select from '../../../../../../commons/Select/Select';
import { ButtonColor, ButtonSize } from '../../../../../../designSystem/Button/Button.types';
import Button from '../../../../../../designSystem/Button/Button';
import { DashboardIPConsultsCOMContext } from '../../DashboardIPConsultsCOM.context';
import { useNafList } from '../../../../../../../hooks/fetchers/useNafList/useNafList';
import { SelectOption } from '../../../../../../commons/Select/Select.types';
import RSelect from 'react-select/dist/declarations/src/Select';

export default ({ closeModal }: DashboardIPConsultsCOMFiltersFormProps) => {
  const { setFilters } = useContext(DashboardIPConsultsCOMContext);

  const [inputValue, setInputValue] = useState<string>()

  const fieldsOfActivityRef = useRef<RSelect[]>([]);

  useEffect(() => {
    fieldsOfActivityRef.current = fieldsOfActivityRef.current.slice(0, [...Array(4)].length);
  }, []);

  const { data: NAFList } = useNafList();

  const formProps = useForm<DashboardIPConsultsCOMFiltersFormSchema>({
    resolver: yupResolver(getIPConsultsCOMFilterSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const {
    handleSubmit,
    control,
    formState: { isValid, errors },
  } = formProps;

  // const domains = useWatch({
  //   control,
  //   name: 'domains',
  // });

  const fieldsOfActivity = useWatch({
    control,
    name: 'fieldsOfActivity',
  });

  const isResetable = useMemo(
    () => Boolean(fieldsOfActivity),
    [fieldsOfActivity]
  );

  const onReinitialize = () => {
    [...Array(2)].map((_, index) => {
      fieldsOfActivityRef.current[index]?.clearValue();
    });
    setFilters({
      domains: [],
      fieldsOfActivity: [],
    });
    // closeModal()
  };

  const onSubmit = handleSubmit(({ fieldsOfActivity }) => {
    setFilters((state) => ({
      ...state,
      fieldsOfActivity: (fieldsOfActivity as string[]) || [],
    }));
    closeModal();
  });

  const updatedFormData = useMemo(
    () =>
      dashboardIPConsultsCOMFiltersFormData.map((row) =>
        row.map((item) => {
          switch (item.name) {
            case 'fieldsOfActivity':
              return {
                ...item,
                options: NAFList
                  ?.filter((item) => item.description.toLowerCase().includes(inputValue?.toLowerCase() || 'Not in list'))
                  ?.map(({ NAF_code, description }) => ({
                    label: description,
                    value: NAF_code.toString(),
                  })),
              };
            default:
              return item;
          }
        })
      ),
    [NAFList, inputValue]
  );

  return (
    <>
      <form className="form" style={{ width: 'calc(100% - var(--spacing-mToL) * 2)' }}>
        {updatedFormData.map((row, rowIndex) => (
          <div key={`row#${rowIndex}`} className="form__row">
            {row.map(({ name, placeholder, label, options, ...props }) => (
              <Controller
                key={`controlledInput#${rowIndex}`}
                name={name}
                render={({ field: { onChange } }) => (
                  <Select
                    // @ts-ignore
                    ref={(ref) => (fieldsOfActivityRef.current[rowIndex] = ref)}
                    key={`select-${name}`}
                    placeholder={placeholder || ''}
                    error={errors[name]?.message as string}
                    onInputChange={(value: string) => setInputValue(value)}
                    {...{ label, options }}
                    {...props}
                    // @ts-ignore
                    onChange={(arr: SelectOption | SelectOption[]) => {
                      if (['department', 'region'].includes(name)) {
                        onChange((arr as SelectOption)?.value);
                      } else {
                        const values = (arr as SelectOption[]).map((item) => {
                          if (typeof item === 'string') {
                            return item;
                          } else {
                            return item.value;
                          }
                        });
                        onChange(values);
                        setInputValue(undefined)
                      }
                    }}
                    // @ts-ignore
                    noOptionsMessage={({ inputValue }) => !inputValue ? 'Chercher un domaine' : 'Aucun résultat trouvé'}
                    isMulti
                  />
                )}
                {...{ control }}
              />
            ))}
          </div>
        ))}
        {isResetable && (
          <Button
            style={{ alignSelf: 'unset' }}
            onClick={(e) => {
              e.preventDefault();
              onReinitialize();
            }}
            size={ButtonSize.Large}
            color={ButtonColor.Contrast}>
            Réinitialiser
          </Button>
        )}
        <Button
          style={{ alignSelf: 'unset' }}
          onClick={(e) => {
            e.preventDefault();
            // setPaymentModalOpen(true);
            onSubmit();
          }}
          size={ButtonSize.Large}
          disabled={!isValid}>
          Appliquer
        </Button>
      </form>
    </>
  );
};
